var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(ref,i){
var img_cover_desktop = ref.img_cover_desktop;
var img_cover_mobile = ref.img_cover_mobile;
var title = ref.title;
var subtitle = ref.subtitle;
var to = ref.to;
return _c('v-card',{key:i,staticClass:"item",attrs:{"to":to,"tile":""}},[_c('img',{class:'video-img primary lighten-2' + (i + 1 < _vm.items.length ? ' mb-2' : ''),attrs:{"loading":"lazy","src":_vm.files +
        (_vm.w <= 600 && img_cover_mobile
          ? img_cover_mobile
          : img_cover_desktop) +
        "?resize=1&w=" + _vm.w,"alt":title}}),_c('div',{staticClass:"caption"},[_c('div',[_c('div',{staticClass:"play-icon d-flex align-end justify-center mb-8"},[_c('v-icon',[_vm._v(" fa fa-play ")])],1),(title)?_c('div',{staticClass:"caption-title text-uppercase white--text font-weight-black text-center"},[_vm._v(" "+_vm._s(title)+" ")]):_vm._e(),(subtitle)?_c('div',{staticClass:"caption-category white--text font-weight-regular text-center mt-2"},[_vm._v(" "+_vm._s(subtitle)+" ")]):_vm._e()])])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }